import { lifecycle, compose, withState, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { applyNowCTAClick } from 'actions/thirdParty'
import BOTCreditCard from './BOTCreditCard'

const withApplyNowElemState = withState('applyNowElem', 'setApplyNowElem', null)

const withMountApplyNowCTAClick = withHandlers({
  mountApplyNowCTAClick: ({ setApplyNowElem, applyNowElem: currentApplyNowElem, applyNowCTAClick }) =>
    () => {
      const newApplyNowElem = document.querySelector('[data-at-credit-apply-now]')
      if (!currentApplyNowElem && newApplyNowElem) {
        newApplyNowElem.addEventListener && newApplyNowElem.addEventListener('click', applyNowCTAClick)
        setApplyNowElem(newApplyNowElem)
      }
    }
})

const with3rdPartyLifecycle = lifecycle({
  componentDidMount() {
    const { mountApplyNowCTAClick } = this.props
    mountApplyNowCTAClick()
  },
  componentDidUpdate() {
    const { mountApplyNowCTAClick } = this.props
    mountApplyNowCTAClick()
  },
  componentWillUnmount() {
    const { applyNowElem } = this.props
    applyNowElem && applyNowElem.removeEventListener && applyNowElem.removeEventListener('click', applyNowCTAClick)
  }
})

export default compose(
  withType({ type: 'BOTCreditCard', placeholders: ['content']}),
  connect(null, { applyNowCTAClick }),
  withApplyNowElemState,
  withMountApplyNowCTAClick,
  with3rdPartyLifecycle
)(BOTCreditCard)
